// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__hPwWd","footer":"ModalInfo_footer__3eckH"};